console.log('process.env',process.env)
const serverList = [
  {
    BASEURL: 'http://192.168.0.199:8892',
  },
  {
    BASEURL: 'https://websiteapi.7li.cn',
  },
  {
    BASEURL: 'https://test-api.7liyx.cn',
  },
  {
    BASEURL: 'https://gameapi.7li.cn',
  },
  {
    BASEURL: 'http://113.219.215.8:8892',
  }
];
let serverArr = serverList[1]
export default serverArr
